import * as React from 'react'

import { mergeProps } from '@base-ui/react/merge-props'
import { useRender } from '@base-ui/react/use-render'

import { cn } from '@crm/shared/lib/styles/utils'

import { badgeVariants, type BadgeVariants } from './badge.variants'

export const Badge = React.forwardRef<
  HTMLSpanElement,
  useRender.ComponentProps<'span'> & BadgeVariants
>(({ className, variant = 'default', render, ...props }, ref) =>
  useRender({
    defaultTagName: 'span',
    ref,
    props: mergeProps<'span'>(
      {
        className: cn(badgeVariants({ variant }), className),
      },
      props,
    ),
    render,
    state: {
      slot: 'badge',
      variant,
    },
  })
)

Badge.displayName = 'Badge'
